import { getUiCustomPageList, getPageSets, getValueSyncManage } from '@/api/sysManage/uiCustom'
import { getUserInfo } from '@/utils/auth'

const state = {
  enable: false, // 是否启用
  pages: [],
  pageSetList: [], // 页面设置列表
  moduleSyncSetList: [] // 模块同步设置信息列表
}

const mutations = {
  CHANGE_DATA: (state, data) => {
    Object.assign(state, data)
  }
}

const actions = {
  initUICustomPageInfo({ commit }, officeList) {
    if (!officeList || officeList.length === 0) {
      commit('CHANGE_DATA', {})
    }
    const ajaxResults = []
    for (let i = 0; i < officeList.length; i += 5) {
      const branchIds = []
      for (let j = i; j < officeList.length && j < i + 5; ++j) {
        branchIds.push(officeList[j].officeId)
      }
      ajaxResults.push(getUiCustomPageList({ branchIds: branchIds.join(',') }))
    }
    Promise.all(ajaxResults).then(resList => {
      const pages = []
      for (const res of resList) {
        pages.push(...res.data)
      }
      commit('CHANGE_DATA', { enable: true, pages })
    }).catch(() => {
      commit('CHANGE_DATA', {})
    })
  },
  async loadUICustomPageInfo({ state, commit }, { pageType, branchId }) {
    if (state.pages.findIndex(p => p.pageType === pageType && p.branchId === branchId) >= 0) {
      return
    }
    await getUiCustomPageList({ pageType, branchIds: branchId }).then(res => {
      commit('CHANGE_DATA', { enable: true, pages: [...state.pages, ...res.data] })
    })
  },
  updateUICustomPageInfo({ state, commit }, { pageType, branchIds }) {
    getUiCustomPageList({ pageType, branchIds: branchIds.length > 0 ? branchIds.join(',') : '' }).then(res => {
      const newPages = state.pages.filter(p => !(p.pageType === pageType && branchIds.includes(p.branchId)))
      newPages.push(...res.data)
      commit('CHANGE_DATA', { pages: newPages })
    }).catch(() => {
      commit('CHANGE_DATA', {})
    })
  },
  async loadPageSetList({ state, commit }, pageTypes) {
    const newPageTypes = pageTypes.filter(p => state.pageSetList.findIndex(ps => ps.pageType === p) < 0)
    if (newPageTypes.length === 0) {
      return
    }
    await getPageSets(newPageTypes).then(res => {
      commit('CHANGE_DATA', { enable: true, pageSetList: [...state.pageSetList, ...res.data] })
    })
  },
  updatePageSetList({ state, commit }, pageTypes) {
    getPageSets(pageTypes).then(res => {
      const newPageSetList = state.pageSetList.filter(ps => !pageTypes.includes(ps.pageType))
      newPageSetList.push(...res.data)
      commit('CHANGE_DATA', { pageSetList: newPageSetList })
    })
  },
  async loadModuleSyncSetInfo({ state, commit }, { module, branchId }) {
    if (state.moduleSyncSetList.findIndex(p => p.module === module && p.branchId === branchId) >= 0) {
      return
    }
    await getValueSyncManage({ module, branchIds: branchId }).then(res => {
      commit('CHANGE_DATA', { moduleSyncSetList: [...state.moduleSyncSetList, ...res.data] })
    })
  },
  updateModuleSyncSetInfo({ state, commit }, { module, branchIds }) {
    getValueSyncManage({ module, branchIds: branchIds.length > 0 ? branchIds.join(',') : '' }).then(res => {
      const newList = state.moduleSyncSetList.filter(p => !(p.module === module && branchIds.includes(p.branchId)))
      newList.push(...res.data)
      commit('CHANGE_DATA', { moduleSyncSetList: newList })
    }).catch(() => {
      commit('CHANGE_DATA', {})
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
